import React from 'react';
import { PAGES } from '../seoPages';
import SeoPage from './SeoPage';

function About() {
  return <SeoPage page={PAGES.about} />;
}

export default About;
